import { EntityWithStatus, ProjectMember } from '../model/entities';
import { Page } from '../model/elements';
import { proxyApiAxios } from './CustomAxios';
import FileSaver from 'file-saver';
import qs from 'qs';

class ProjectMemberApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        grouped: boolean,
        hubId: string,
        projectId: string[],
        searchText?: string,
    ): Promise<Page<ProjectMember>> => {
        const response = await proxyApiAxios.get<Page<ProjectMember>>('/project-members', {
            params: { page, size, sortField, sortOrder, grouped, hubId, projectId, searchText },
            paramsSerializer: (params) => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;

        return response.data;
    };

    updateCompany = async (
        projectMembers: ProjectMember[],
        hubId: string,
    ): Promise<EntityWithStatus<ProjectMember>[]> => {
        const response = await proxyApiAxios.patch<EntityWithStatus<ProjectMember>[]>(
            `/project-members`,
            projectMembers,
            {
                params: { hubId, company: '' },
            },
        );
        return response.data;
    };

    updateRoles = async (
        projectMembers: ProjectMember[],
        hubId: string,
    ): Promise<EntityWithStatus<ProjectMember>[]> => {
        const response = await proxyApiAxios.patch<EntityWithStatus<ProjectMember>[]>(
            `/project-members`,
            projectMembers,
            {
                params: { hubId, roles: '' },
            },
        );
        return response.data;
    };

    updateCostCenter = async (
        projectMembers: ProjectMember[],
        hubId: string,
    ): Promise<EntityWithStatus<ProjectMember>[]> => {
        const response = await proxyApiAxios.patch<EntityWithStatus<ProjectMember>[]>(
            `/project-members`,
            projectMembers,
            {
                params: { hubId, costCenter: '' },
            },
        );
        return response.data;
    };

    exportSpreadSheet = async (
        sortField: string,
        sortOrder: boolean,
        hubId: string,
        projectId: string[],
        grouped: boolean,
        searchText?: string,
    ) => {
        const response = await proxyApiAxios.get<Blob>(`/project-members/spreadsheets`, {
            responseType: 'blob',
            params: { sortField, sortOrder, hubId, projectId, grouped, searchText },
            paramsSerializer: (params) => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
        });
        FileSaver.saveAs(response.data, 'preconnector-project-members.xlsx');
    };

    import = async (projectMembers: ProjectMember[], hubId: string): Promise<EntityWithStatus<ProjectMember>[]> => {
        const response = await proxyApiAxios.post<EntityWithStatus<ProjectMember>[]>(
            '/project-members/imports',
            projectMembers,
            { params: { hubId } },
        );

        return response.data;
    };

    delete = async (projectMembers: ProjectMember[], hubId: string): Promise<EntityWithStatus<ProjectMember>[]> => {
        const response = await proxyApiAxios.delete<EntityWithStatus<ProjectMember>[]>('/project-members/bulk', {
            params: { hubId },
            data: projectMembers,
        });

        return response.data;
    };

    loadCsv = async (csv: string, hubId: string, projectId: string[]): Promise<ProjectMember[]> => {
        const response = await proxyApiAxios.post<ProjectMember[]>('/project-members/csvs', csv, {
            headers: {
                'Content-Type': 'text/plain',
            },
            params: { hubId, projectId },
            paramsSerializer: (params) => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
        });
        return response.data;
    };

    loadSpreadsheet = async (file: any, hubId: string, projectId: string[]): Promise<ProjectMember[]> => {
        const formData: FormData = new FormData();
        formData.append('file', file);
        const response = await proxyApiAxios.post<any>('/project-members/spreadsheets', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            params: { hubId, projectId },
            paramsSerializer: (params) => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
        });
        return response.data;
    };
}

const projectMemberApi: ProjectMemberApi = new ProjectMemberApi();
export default projectMemberApi;
